import { render, staticRenderFns } from "./CalendarDetail.vue?vue&type=template&id=313e743a&"
import script from "./CalendarDetail.vue?vue&type=script&lang=js&"
export * from "./CalendarDetail.vue?vue&type=script&lang=js&"
import style0 from "./CalendarDetail.vue?vue&type=style&index=0&id=313e743a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports